import { createGoblinModel } from './goblin-model.js';
import type { UnitDefinition } from '../../../shared/game/world-types.js';
import { createHumanModel, type HumanModelOptions } from './human-model.js';
import { createOrcModel } from './orc-model.js';
import { createElfModel } from './elf-model.js';
import { createDwarfModel } from './dwarf-model.js';
import { createCelestialModel } from './celestial-model.js';
import { createHalflingModel } from './halfling-model.js';
import { withFigureTape } from './figure-tape.js';
export type { CharacterRig, LimbRig } from './character-rig.js';

/** Ancestry adapters supply their body and face morphs to the shared humanoid builder. A baked figure replays its slow steps (`figure-tape.ts`). */
export function createCharacterModel(definition: UnitDefinition, options?: HumanModelOptions) {
  return withFigureTape(definition, options, () => buildCharacterModel(definition, options));
}
function buildCharacterModel(definition: UnitDefinition, options?: HumanModelOptions) {
  return definition.appearance?.ancestry === 'goblin' ? createGoblinModel(definition, options)
    : definition.appearance?.ancestry === 'orc' ? createOrcModel(definition, options)
    : definition.appearance?.ancestry === 'elf' ? createElfModel(definition, options)
    : definition.appearance?.ancestry === 'dwarf' ? createDwarfModel(definition, options)
    : definition.appearance?.ancestry === 'celestial' ? createCelestialModel(definition, options)
    : definition.appearance?.ancestry === 'halfling' ? createHalflingModel(definition, options) : createHumanModel(definition, options);
}
